import React from 'react'
import Layout from "../components/App/Layout"
import Navbar from "../components/App/Navbar"
import PageBanner from '../components/Common/PageBanner'
import Footer from "../components/App/Footer"
import ServiceDetailsContentdw from '../components/ServiceDetailsdw/ServiceDetailsContentdw'
import RelatedServicesdw from '../components/ServiceDetailsdw/RelatedServicesdw'

const Details = () => {
    return (
        <Layout>
            <Navbar />
            <PageBanner
                pageTitle="Data Warehousing  "
                homePageText="Home"
                homePageUrl="/"
                activePageText="Service Details"
            />
            <ServiceDetailsContentdw />
            <RelatedServicesdw />
            <Footer />
        </Layout>
    );
}

export default Details